import { useState } from 'react';

const navItems = [
  { label: '总览', href: '#top' },
  { label: '分类索引', href: '#categories' },
  { label: '热度榜', href: '#ranking' },
  { label: '资源合集', href: '#collections' },
  { label: '更新动态', href: '#updates' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-6 lg:px-10">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-layout-grid-fill text-lg" />
          </span>
          <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            黑料总站
          </h1>
          <span className="hidden rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] tracking-wide text-secondary-900 lg:inline-block">
            全量分类汇总
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 font-label text-[13px] text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <span className="flex items-center gap-1.5 font-label text-[12px] text-foreground-500">
            <i className="ri-refresh-line" />
            今日已更新 42 条
          </span>
          <a
            href="#categories"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 font-label text-[13px] text-background-50 transition-colors hover:bg-foreground-800"
          >
            <i className="ri-compass-3-line" />
            开始浏览
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer border-b border-background-100 py-3 font-label text-sm text-foreground-700"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#categories"
            onClick={() => setOpen(false)}
            className="mt-4 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-3 font-label text-sm text-background-50"
          >
            <i className="ri-compass-3-line" />
            开始浏览
          </a>
        </div>
      ) : null}
    </header>
  );
}